// extracted by mini-css-extract-plugin
module.exports = {"componentsTitle":"style_componentsTitle__m5Iv0","list":"style_list__k9pUw","category":"style_category__yJw1h"};